<div
  class="gw-mt-6 gw-border-base md:gw-rounded-2xl gw-bg-background-elevation-1"
>
  <div
    class="gw-border-content-header gw-border-0 gw-border-b gw-border-b-[1px] gw-border-b-border-normal gw-border-solid gw-bg-background-elevation-1 gw-h-[56px] gw-flex gw-justify-between gw-items-center gw-pt-4 gw-px-4 md:gw-px-6"
  >
    <p class="gw-text-[16px] title gw-font-bold gw-text-text-primary">
      Configuração Assinatura
    </p>
  </div>

  <div
    class="gw-bg-background-elevation-1 gw-rounded-2xl gw-py-x-large gw-px-medium md:gw-p-x-large"
  >
    <form
      [formGroup]="formSubscribe"
      class="gw-rounded-2xl gw-flex-col gw-gap-6 gw-text-base gw-bg-background-elevation-1 gw-w-full"
    >
      <div class="gw-w-full gw-flex gw-flex-col md:gw-flex-row gw-gap-x-large">
        <div>
          <label class="form-label" for="paymentTiming">
            {{
              'features.subscriptionsPlans.form.labels.paymentTiming'
                | translate
            }}
          </label>
          <div class="gw-flex gw-gap-medium">
            <gatewee-radio-button
              formControlName="type"
              label="Limitado"
              name="type"
              id="limited"
              value="limited"
            >
            </gatewee-radio-button>
            <gatewee-radio-button
              formControlName="type"
              label="Indefinido"
              name="type"
              id="indefinite"
              value="indefinite"
            >
            </gatewee-radio-button>
          </div>
        </div>

        <div class="gw-w-full md:gw-flex-1">
          <gatewee-select-v3
            label="Método de pagamento"
            formControlName="paymentMethod"
            [items]="paymentMethods"
            placeholder="Selecione o método de pagamento"
          ></gatewee-select-v3>
        </div>

        <div
          class="gw-w-full md:gw-flex-1"
          *ngIf="
            formSubscribe.get('type')?.value === 'indefinite';
            else limited
          "
        >
          <gatewee-datepicker-v2
            formControlName="billingDate"
            [minDate]="today"
            label="Data de cobrança"
          ></gatewee-datepicker-v2>
        </div>

        <ng-template #limited>
          <div class="gw-w-full md:gw-flex-1">
            <gatewee-datepicker-v2
              formControlName="initialDate"
              [minDate]="today"
              label="Data início"
            ></gatewee-datepicker-v2>
          </div>
          <div class="gw-w-full md:gw-flex-1">
            <gatewee-datepicker-v2
              formControlName="endDate"
              [minDate]="today"
              label="Data fim"
            ></gatewee-datepicker-v2>
          </div>
        </ng-template>
      </div>

      <div
        *ngIf="isPixAutomatic"
        class="gw-mt-medium gw-rounded-lg gw-bg-background-elevation-2 gw-border gw-border-border-normal gw-p-medium gw-space-y-2"
      >
        <p class="gw-m-0 gw-font-semibold gw-text-text-primary gw-text-sm">
          {{
            'features.subscriptions.view.pixAutomatic.calloutTitle' | translate
          }}
        </p>
        <p class="gw-m-0 gw-text-text-secondary gw-text-sm">
          {{
            'features.subscriptions.view.pixAutomatic.calloutBody' | translate
          }}
        </p>
        <p
          *ngIf="showPrepaidHint"
          class="gw-m-0 gw-text-text-secondary gw-text-sm"
        >
          {{
            'features.subscriptions.view.pixAutomatic.prepaidHint' | translate
          }}
        </p>
        <p
          *ngIf="showPostpaidHint"
          class="gw-m-0 gw-text-text-secondary gw-text-sm"
        >
          {{
            'features.subscriptions.view.pixAutomatic.postpaidHint' | translate
          }}
        </p>
        <p
          *ngIf="showStartDateMin3DaysWarning"
          class="gw-m-0 gw-text-status-negative gw-text-sm"
        >
          {{
            'features.subscriptions.view.pixAutomatic.startDateMin3Days'
              | translate
          }}
        </p>
      </div>

      <div class="gw-w-full gw-mt-x-large">
        <label class="gw-form-label">Descrição</label>
        <textarea
          class="gw-textarea-base placeholder:gw-text-text-tertiary"
          formControlName="description"
          placeholder="Insira seu texto aqui..."
        ></textarea>
      </div>

      <div class="gw-section-divider gw-my-x-large">
        <span class="gw-section-divider-line"></span>
        <span class="gw-section-divider-text">Configurações Adicionais</span>
        <span class="gw-section-divider-extender"></span>
      </div>

      <div class="gw-flex md:gw-flex-row gw-flex-col gw-gap-[16px]">
        <gatewee-checkbox
          label="Enviar informações de cobrança"
          formControlName="invoices"
        ></gatewee-checkbox>
        <gatewee-checkbox
          *ngIf="!isPixAutomatic"
          label="Pré-emitir faturas"
          formControlName="hasPreEmittedInvoices"
        ></gatewee-checkbox>
      </div>
    </form>
  </div>
</div>
